import globalValues from '@/core/helpers/enums/globalValues';
import i18n from '@/i18n';
import { http } from '@/utils/http.util';

export default class AnswerService {
   async postAnswer(answer: Object) {
      return await http
         .post('/api/answer', answer)
         .then((response) => {
            return response.data;
         })
         .catch((error) => {
            return Promise.reject(error.response?.data ?? error);
         });
   }

   async postBulkAnswers(formData: FormData) {
      return await http
         .post('/api/answer/bulk', formData)
         .then((response) => {
            return response.data;
         })
         .catch((error) => {
            return Promise.reject(error.response?.data ?? error);
         });
   }

   async postAnswers(answers: any) {
      const payload = {
         candidate_step_id: Number(sessionStorage.getItem(globalValues.candidate.stepId)),
         submission_random: sessionStorage.getItem(globalValues.candidate.journeyRandom) || '',
         answers: [
            {
               module_id: answers.moduleId,
               choices: answers.choices.map((choice: any) => ({
                  id: choice.id,
                  content: choice.content || null,
               })),
            },
         ],
      };

      return await this.postBulkAnswers(payload);
   }

   async patchAnswer(id: Number, body: any, submission_random: string) {
      return await http
         .patch(`/api/answer/${id}`, body, {
            headers: { 'submission-random': submission_random },
         })
         .then((response) => response.data)
         .catch(() => {
            throw Error(i18n.global.t('error.couldNotEditAnswer'));
         });
   }

   async deleteAnswer(id: Number, submission_random: string) {
      return await http
         .delete(`/api/answer/${id}`, {
            data: { submission_random },
         })
         .then((response) => response.data)
         .catch(() => {
            throw Error(i18n.global.t('error.couldNotEditAnswer'));
         });
   }
}

